const messengerServicesRoutes = [
  {
    path: "groups",
    name: "Groups",
    redirect: {
      name: "Group List"
    },
    component: () =>
      import(/* webpackChunkName: "events" */ "../../views/messengerService/MessengerService.vue"),
    children: [
      {
        path: "list",
        name: "Group List",
        component: () =>
          import(/* webpackChunkName: "events" */ "../../views/messengerService/MessengerServiceList.vue")
      },
      {
        path: "detail/:id",
        name: "Group Detail",
        component: () =>
          import(/* webpackChunkName: "events" */ "../../views/messengerService/MessengerServiceDetail.vue")
      }
    ]
  }
];

export default messengerServicesRoutes;
